/*
 * @Author: your name
 * @Date: 2020-07-30 15:32:11
 * @LastEditTime: 2020-08-03 17:01:56
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: /xdap-h5/src/vender/form-schema-config/components/form-money-input.config.js
 */
import MoneyUtil from '@/lib/ui/utils/money.util.js'

const FormMoneyInputConfig = {
  // 类型
  componentType: 'FORM_MONEY_INPUT',
  // 部件显示样式
  widgetConfig: {
    icon: 'form-money',
    text: '金额',
    optionTitle: true,
    description: '用于输入金额并显示特殊格式，最大长度限制16位'
  },
  componentConfig: {
    uuid: `32bit uuid`,
    width: 6, // 3, 6, 9, 12
    height: 1,
    render: {
      ide: 'FormMoneyInput',
      edit: 'FormMoneyInput',
      read: 'FormMoneyInput'
    },
    lengthLimit: 200,
    enableRule: false,
    moneyDisplayStyle: 'NUMBER',
    label: '金额',
    placeholder: '请输入金额',
    methods: {
      lcInitData: {
        edit: (...args) => {
          console.log(args)
        }
      },
      lcFormatValue: (value, config) => {
        let realResult = ''
        try {
          if (MoneyUtil.isAnNumber(value)) {
            if (Object.prototype.toString.call(value) === `[object String]`) {
              if (value.length <= 15) {
                realResult = (Math.floor(parseFloat(value) * 100) / 100).toString()
              }
            } else if (Object.prototype.toString.call(value) === `[object Number]`) {
              const data = value.toLocaleString().replace(/,/g, '')
              if (data.length <= 15) {
                realResult = (Math.floor(value * 100) / 100).toString()
              }
            }
          }
        } catch (error) {
          realResult = null
        }
        return realResult
      },
      lcValidateValue: (value, config) => {
        if (value === '') {
          return true
        }
        if (MoneyUtil.isAnNumber(value)) {
          return true
        } else {
          return false
        }
      }
    },
    inTable: true
  },
  methods: {},
  editorConfig: [
    'INFO',
    'LABEL',
    'PLACEHOLDER',
    'MONEY_DISPALY',
    'NUMBER_RANGE',
    'MONEY_DEFAULT',
    'WIDTH',
    'HIDDEN',
    'READONLY',
    'REQUIRED',
    'EDITONNEW',
    'UNIQUE'
  ],
  excludeEditorConfigInTable: ['WIDTH']
}

export default FormMoneyInputConfig
